import api from '../../plugins/api';

// Ð¡Ð¿Ð¸ÑÐ¾Ðº Ð¼Ð°ÑÐ¾Ðº, Ð½Ð°ÑÑÑÐ¾ÐµÐ½Ð½ÑÑ Ð´Ð»Ñ Ð¿ÑÑÐ¼Ð¾Ð³Ð¾ Ð¸Ð¼Ð¿Ð¾ÑÑÐ° Ð¸Ð· ÐÐ¸ÑÑÐ¸ÐºÑÐ° (appsettings â BITRIX_STOCK)
const getBitrixMarks = () => api.get('/api/crm/cars/bitrixStock/marks');

export default getBitrixMarks;
